module.exports = __webpack_public_path__ + "img/maincamera.c52841a2.png";